import { jsx } from "react/jsx-runtime";
import { Box } from "braid-design-system";
import striptags from "striptags";
import { parseHTML as parseHTML$1, parseHTML_isDescription } from "../JobCard.css.mjs";
const generateJobTitleLinkId = (id) => `job-title-${id}`;
const getJobDataAutomation = (isPremium, locationMatch) => {
  if (isPremium) {
    return "premiumJob";
  }
  if (locationMatch === "Exact") {
    return "tier1job";
  }
  return "normalJob";
};
const parseHTML = (text, tag) => {
  const regex = RegExp(`<${tag}>(.*?)</${tag}>`);
  return text.split(regex).reduce(
    (result, txt, index) => {
      if (txt !== "") {
        result.push({
          text: txt,
          highlight: index % 2 === 1
        });
      }
      return result;
    },
    []
  );
};
const highlightFromHTML = ({
  html,
  isDescription = false
}) => parseHTML(html, "b").map(({ highlight, text }, index) => {
  const cleanText = striptags(text).replace(/\u00A0/g, " ");
  return highlight ? /* @__PURE__ */ jsx(
    Box,
    {
      component: "mark",
      data: {
        automation: "jobItem-highlight"
      },
      className: [
        parseHTML$1,
        {
          [parseHTML_isDescription]: isDescription
        }
      ],
      children: cleanText
    },
    index
  ) : cleanText;
});
export {
  generateJobTitleLinkId,
  getJobDataAutomation,
  highlightFromHTML
};
